module.exports = __webpack_public_path__ + "static/media/getting-support-large@3x.d5748e5a.png";